<template>
  <div
    v-if="src"
    class="image-modal"
    @click="$emit('hide')">
    <div @click.stop>
      <div
        class="container image-modal-image">
        <p
          class="image-modal-image__cross"
          @click="$emit('hide')">
          <b-icon-x-circle-fill />
        </p>
        <a
          :href="src"
          target="_blank">
          <b-img-lazy
            :blank-src="blankSrc"
            :src="src"
            class="image-modal-image__img" />
        </a>
      </div>
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    src: {
      type: String,
      required: true
    },
    blankSrc: {
      type: String,
      required: true
    }
  },
}
</script>

<style lang="scss" scoped>
.image-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2000;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

.image-modal-image {
  position: relative;
  display: flex;
  &__cross {
    position: absolute;
    top: -18px;
    right: 5px;
    font-size: 20px;
    cursor: pointer;
    @media screen and (min-width:992px) {
      top: -26px;
      right: 2px;
      font-size: 30px;
    }
  }
  &__img {
    object-fit: cover;
    width: 100%;
    max-width: 600px;
  }
}
</style>